import { render, staticRenderFns } from "./tag-checkbox.vue?vue&type=template&id=0528389c&"
import script from "./tag-checkbox.vue?vue&type=script&lang=js&"
export * from "./tag-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports